import React from 'react'
import Plan from './Plan'
import { Button } from 'react-bootstrap'
export default class TestPlan extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      employeeId: 'KKC0011',
      contractorId: '1'
    }
  }

  onEmployeeClick() {
    this.setState((prevState) => {
      if (prevState.employeeId === 'KKC0011')
        return { employeeId: '' }
      else
        return { employeeId: 'KKC0011' }
    })
  }

  onContractorClick() {
    this.setState((prevState) => {
      if (prevState.contractorId === '1')
        return { contractorId: '2' }
      else
        return { contractorId: '1' }
    })
  }

  render() {
    return (
      <div>
        <Button onClick={this.onEmployeeClick.bind(this)}>เปลียยน employee id</Button>
        <Button onClick={this.onContractorClick.bind(this)}>เปลียยน contractor id</Button>
        <Plan employeeId={this.state.employeeId} />
        {/* <Plan contractorId={this.state.contractorId} /> */}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/view/workdoc/plan/TestPlan.js